import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from "../../../assets/img/logo.png"; // Adjust path as needed

const CommonNavbar = () => {
  return (
    <Navbar bg="light" variant="light" sticky="top" expand="lg" style={{padding:"0px"}}>
      <Container>
        <Navbar.Brand href="/">
          <img
            src={logo}
            alt="Logo"
            width="80"
            height="80"
            className="d-inline-block align-top"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav" className="justify-content-end">
          <Nav>
            
            <Nav.Link className="btn btn-primary text-white pl-4 pr-4" href="/create-account">Book Appointment</Nav.Link>
            <Nav.Link className="btn btn-primary text-white ml-2 pl-4 pr-4" href="/login">Login</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CommonNavbar;
